export default "__VITE_ASSET__BFLiH2uZ__"